import React from 'react';
import Link from 'next/link';
import { createImageProxyUrl } from 'app/utils/svtimage';
import { stripEms, getUrl, value } from './helpers';
import {
    SearchSuggestionEpisodeText,
    SearchSuggestionLink,
    SearchSuggestionLinkText,
    SearchSuggestionThumbnail,
    ThumbNailImage,
    SearchSuggestionTextWrapper,
    SearchSuggestionLinkByline,
} from './AutoCompleteResult.styles';

import PlayBadge, { PlayBadgeSize } from '../../../ui-components/PlayBadge/PlayBadge';
import { fontWeightBold } from '../../../ui-components/design-tokens';
import { SIZE } from '../../../ui-components/typography/PlayText/PlayText';
import useTrackImpression from '../../../utils/useTrackImpression';

const getThumbnail = (teaser = {}) => {
    if (teaser.images) {
        return createImageProxyUrl(
            teaser.images.wide.id,
            teaser.images.wide.changed,
            'wide',
            140,
            'quality=90'
        );
    }

    return createImageProxyUrl(teaser.image.id, teaser.image.changed, 'wide', 140, 'quality=90');
};

const getThumbnailAlt = (teaser = {}) => {
    if (teaser.images) {
        return teaser.images.wide.description;
    }

    return teaser.heading ? `${stripEms(teaser.heading)} bild` : undefined;
};

const getHeading = (teaser = {}) => (teaser.heading ? stripEms(teaser.heading) : undefined);

const getSubheading = (teaser = {}) => (teaser.subHeading ? stripEms(teaser.subHeading) : undefined);

const PopOverLink = ({ item, suggestionClick, itemPosition = 'unknown position', onItemImpression }) => {
    const teaser = item.teaser || item.categoryTeaser || {};
    const contentId = teaser.id || teaser.item?.svtId;
    const [trackingRef] = useTrackImpression(onItemImpression, itemPosition + 1, contentId);
    const thumbnail = getThumbnail(teaser);
    const thumbnailAltText = getThumbnailAlt(teaser);

    return (
        <Link href={getUrl(item)} passHref>
            <SearchSuggestionLink
                data-rt-spec="auto-complete-link"
                onMouseDown={() => {
                    suggestionClick(value(item));
                }}
                ref={trackingRef}
            >
                {thumbnail && (
                    <SearchSuggestionThumbnail>
                        {teaser.badge && (
                            <PlayBadge
                                text={teaser.badge.text}
                                theme={teaser.badge.type}
                                accessibilityText={teaser.badge.altText}
                                overlay
                                size={PlayBadgeSize.SMALL}
                            />
                        )}
                        <ThumbNailImage key={thumbnail} src={thumbnail} alt={thumbnailAltText} />
                    </SearchSuggestionThumbnail>
                )}
                <SearchSuggestionTextWrapper>
                    <SearchSuggestionLinkByline as="span">{teaser?.byline}</SearchSuggestionLinkByline>
                    <SearchSuggestionLinkText className="linkText" weight={fontWeightBold} size={SIZE.LARGE}>
                        {getHeading(teaser)}
                    </SearchSuggestionLinkText>
                    <SearchSuggestionEpisodeText>{getSubheading(teaser)}</SearchSuggestionEpisodeText>
                </SearchSuggestionTextWrapper>
            </SearchSuggestionLink>
        </Link>
    );
};

export default PopOverLink;
